import React from 'react';
import './PublicationsListAdmin.scss';
import { publicationTags } from '../../config/publicationTags';

const tagLabelById = new Map(publicationTags.map(t => [t.id, t.label]));

// Admin publications table with actions (edit, download, delete)
export default function PublicationsListAdmin({ publications, loading, error, onEdit, onDelete }) {
  if (loading) return <div>Loading publications...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;
  if (!publications || publications.length === 0) {
    return <div className="publications-list-empty">No publications found.</div>;
  }
  return (
    <table className="admin-table">
      <thead>
        <tr>
          <th>File Name</th>
          <th>Title</th>
          <th>Description</th>
          <th>Tags</th>
          <th className="action-col"></th>
          <th className="action-col"></th>
          <th className="action-col"></th>
        </tr>
      </thead>
      <tbody>
        {publications.map((pub, idx) => (
          <tr key={pub.name + idx}>
            <td>{pub.name}</td>
            <td>{pub.metadata?.title || ''}</td>
            <td>{pub.metadata?.description || ''}</td>
            <td>{pub.metadata?.outlooks ? pub.metadata.outlooks.map(s => s.trim()).filter(Boolean).map(id => tagLabelById.get(id) || id).join(', ') : ''}</td>
            <td className="action-col"><a href={pub.sasUrl} download target="_blank" rel="noopener noreferrer">Download</a></td>
            <td className="action-col"><button type="button" onClick={() => onEdit(pub)} className="btn-edit">Edit</button></td>
            <td className="action-col"><button type="button" onClick={() => onDelete(pub)} className="btn-edit">Delete</button></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
